module.exports = __webpack_public_path__ + "static/media/open-message-correct.96651918.png";